module.exports = __webpack_public_path__ + "1791188489487/fonts/fa-solid-900.b75b4bf.woff2";